import { Component, OnInit, OnDestroy } from '@angular/core';
import { ViewChild, ElementRef } from '@angular/core';
import { ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { ModalController, NavParams } from '@ionic/angular';

import { Place } from '@app/modules/model/place';
import { Audit } from '@app/modules/model/audit';

import { Subject } from 'rxjs';

import { toastService } from '@app/modules/common/toast';
import { languageService, languageSupport } from '@app/modules/common/language';
import { syncService } from '@app/modules/sync';
import { viewService } from '@app/modules/view';
import { dataService } from '@app/modules/data';

/************************************/
/* AUDIT MODAL                      */
/************************************/

@Component({
    selector: 'modal-audit',
    templateUrl:'./ui-audit-modal.html',
    styleUrls: [ 
        'ui-audit-modal.scss'
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class UiAuditModal extends languageSupport implements OnInit, OnDestroy {
    public _place: Place = null;
    public _audit: Audit = null;
    
    /****************************/
    /* STARTS HERE              */
    /****************************/

    private _online_subscription = null;
    private _audit_subscription = null;
    private _destroyed = false;
    private _breakdownLoading = false;
    get BreakdownLoading(){
        return this._breakdownLoading;
    }

    constructor(private lang: languageService, private change: ChangeDetectorRef, private toast: toastService, private modalCtrl: ModalController, private params: NavParams, private sync: syncService, private data: dataService, public view: viewService) {
        super(lang, change);
    }

    ngOnInit(){
        this._audit = this.params.get('audit');
        if (this._audit){
            this._place = this._audit.place;
        }

        this._online_subscription = this.view.OnOnline.subscribe(
        data => {
            this.change.markForCheck();
        });

        this._audit_subscription = this._audit.OnRefresh.subscribe(
        data => {
            this.change.markForCheck();
        });

        // Fuente unica = servidor. Los importes/contadores se muestran de la
        // foto persistida del AUDITINFO (calculada por el till del cierre al
        // cerrar); NO se recomputan en el cliente. El recompute local
        // (ReloadInfo) usaba la memoria + el till del dispositivo que MIRA el
        // cierre, de modo que un TPV veia el cierre de OTRO con sus propias
        // cifras y su propia serie (bug MultiplePOS). El desglose de IVA y la
        // numeracion por serie los recalcula el servidor filtrando por el
        // till del cierre (recalculate.php) — no se tocan en local.
        // Solo con conexion (recalculate.php es una request pesada:
        // light=false recomputa el desglose), y solo si aun NO tenemos en
        // cache el IVA Y la numeracion por serie — asi no se recomputa en
        // cada apertura cuando ya estan cargados. Offline se muestra la foto
        // persistida del AUDITINFO (importes) y el print usa el fallback
        // local para la numeracion por serie.
        let _ai = this._audit ? this._audit.auditinfo : null;
        let _hasBreakdown = _ai && Array.isArray(_ai.taxbreakdown) && (_ai.taxbreakdown.length > 0);
        let _hasSeries = _ai && Array.isArray(_ai.ServerSeriesRanges);
        if (_ai && _ai.tickets && _ai.tickets.completed_amount > 0 &&
            this.view.IsOnline && !(_hasBreakdown && _hasSeries)){
            this._breakdownLoading = true;
            this._FetchAuditHot();
        }
    }

    private _FetchAuditHot(){
        this.data.DoRequest('auditinfo/recalculate.php', { audit: this._audit.objid }, null, false).then(
        (res: any) => {
            if (this._destroyed){
                return;
            }
            if (res && res['errorcode'] == 0 && res['info']){
                if (Array.isArray(res['info']['taxbreakdown'])){
                    const _current = this._audit.auditinfo.Info;
                    this._audit.auditinfo.Info = Object.assign({}, _current, { taxbreakdown: res['info']['taxbreakdown'] });
                }
                if (Array.isArray(res['info']['seriesranges'])){
                    this._audit.auditinfo.ServerSeriesRanges = res['info']['seriesranges'];
                }
                // now=true: emit sincrono. Sin esto OnRefresh se difiere
                // al siguiente OnRefreshTick (~250ms) y el overlay se
                // quita antes de que print-audit invalide _report.
                this._audit.DoRefresh('AUDIT', true);
                this._audit.auditinfo.DoRefresh('AUDITINFO', true);
            }
            this._breakdownLoading = false;
            this.change.markForCheck();
        }).catch(err => {
            if (this._destroyed){
                return;
            }
            console.warn("[AUDIT MODAL] hot recalculate failed:", err);
            this._breakdownLoading = false;
            this.change.markForCheck();
        });
    }
    
    ngOnDestroy(){
        this._destroyed = true;
        super.OnDestroy();

        if (this._online_subscription){
            this._online_subscription.unsubscribe();
            this._online_subscription = null;
        }

        if (this._audit_subscription){
            this._audit_subscription.unsubscribe();
            this._audit_subscription = null;
        }
    }

    OnClose(){
        this.modalCtrl.dismiss(null);
    }

    private _isready = false;
    get IsReady(){
        return this._isready;
    }
    OnReady(value: boolean){
        this._isready = value;
        this.change.markForCheck();
    }

    /****************************/
    /* EVENT HANDLERS           */
    /****************************/
        
    private _onprint = new Subject<any> ();  

    private onprint = this._onprint.asObservable();
    get OnPrint(){
        return this.onprint;
    }

    @ViewChild('printable', {static: false} ) _printable: ElementRef;
    PrintBrief(){
        if (!this._isready || this._breakdownLoading){
            return;     // do not allow printing until data + breakdown ready
        }
        this._onprint.next();
        this.OnClose();
    }
}